import { createContext } from 'react'

import { Attendee, Meeting } from '../../../../common/src/api/www'

// For Crew
export type Information = {
  property: string
  deviceName: string | number
  requirement?: string
  language?: string
}

type MeetingContextValue = {
  meeting?: Meeting | null
  setMeeting: (value?: Meeting) => void
  attendee?: Attendee | null
  setAttendee: (value?: Attendee) => void
  information?: Information | null
  setInformation: (value?: Information) => void
  isRedial: boolean
  setIsRedial: (value: boolean) => void
}

export const MeetingContext = createContext<MeetingContextValue>({
  meeting: null,
  setMeeting: () => {},
  attendee: null,
  setAttendee: () => {},
  information: null,
  setInformation: () => {},
  isRedial: false,
  setIsRedial: () => {},
})
